import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { VAM_SERVICE } from '@eggplant/api-hosts'
import type { ReactElement } from 'react'
import type { Suite } from '@eggplant/types'

interface Props {
  id: string
  shortErrorMessage?: string
  children?: (data: Suite) => ReactElement
  onSuccess?: (data: Suite) => void
}

const GetSuiteRequest = ({
  id,
  shortErrorMessage,
  children,
  onSuccess
}: Props) => {
  const url = `${VAM_SERVICE}/assets/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onSuccess={onSuccess}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetSuiteRequest
